import { Dialog, DialogContent, DialogHeader, Icon, ToastLevel, useIntl, useToast } from "@metsooutotec/modes-react-components"
import React, { FC, useState } from "react"
import { StoreResults } from "stores/stores-helper"
import stockManagementStore from "../../stores/stock-management-store"
import ModalsButtons from "components/common/modals-buttons"

interface StockAllocationDeleteEntityProps {
    isOpen: boolean | undefined
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
    macAddresses: string[]
    partNumber: string
}

const StockAllocationDeleteModal: FC<StockAllocationDeleteEntityProps> = ({ isOpen, setIsOpen, macAddresses, partNumber }) => {
    const { formatMessage } = useIntl()
    const [isLoading, setLoading] = useState<boolean>(false)
    const [isError, setIsError] = useState<{ isError: boolean; errorMessage: string }>({ isError: false, errorMessage: "" })
    const { setMessage } = useToast()

    const labels = {
        header: `${formatMessage("deleteAllocation.header")}: #${macAddresses.length}`,
        entityTitle: formatMessage("deleteAllocation.entityTitle"),
        warning: formatMessage("deleteAllocation.warning"),
    }

    const onConfirm = async (e: React.FormEvent): Promise<void> => {
        try {
            setLoading(true)
            setIsError({ isError: false, errorMessage: "" })
            let result: StoreResults = await stockManagementStore.deleteStockAllocation({
                listOfSensorsMacAddress: macAddresses,
                partNumber: partNumber,
            })

            if (!result.passed) {
                setLoading(false)
                setIsError({ isError: true, errorMessage: result.message })
                return
            }

            setMessage("Sensors have been reset!", ToastLevel.SUCCESS, 3000)
            // Handle success

            console.log("Form submitted successfully!", result.message)
            onClose()
        } catch {
            console.log("Something went wrong on StockAllocationDeleteModal")
        } finally {
            setLoading(false)
        }
    }

    function onClose() {
        setLoading(false)
        setIsOpen(false)
    }
    return (
        <>
            <Dialog open={isOpen} dimmer size='small' style={{ maxWidth: "696px" }}>
                <DialogHeader>{labels.header}</DialogHeader>
                {isError.isError && <p style={{ color: "red" }}>{isError.errorMessage}</p>}
                <DialogContent data-cy='dialog-content'>
                    <>
                        {labels.entityTitle}.{" "}
                        <div style={{ width: "100%", textAlign: "center", marginTop: "3em" }}>
                            <Icon className='icon-info-o-24' /> {labels.warning}
                        </div>
                    </>
                </DialogContent>
                <ModalsButtons handleSubmit={onConfirm} onCloseProcess={onClose} isLoading={isLoading} />
            </Dialog>
        </>
    )
}
export default StockAllocationDeleteModal
